export default __webpack_public_path__ + "static/media/chairs002.40072472.jpeg";